/**
 * Small motion helpers built on `motion` (Framer Motion).
 *
 * `<FadeIn>` — fades + lifts its child in on mount, with an optional
 * index-based stagger for lists/grids. Respects `prefers-reduced-motion`
 * (framer animates via JS transforms, which the global CSS reduced-motion
 * reset does not neutralize, so we gate here explicitly).
 */

import { motion, useReducedMotion } from "motion/react";
import type { ReactNode } from "react";

export function FadeIn({
  children,
  index = 0,
  className,
}: {
  children: ReactNode;
  /** Position in a list — adds a small staggered delay (capped). */
  index?: number;
  className?: string;
}) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.2,
        ease: "easeOut",
        delay: reduce ? 0 : Math.min(index * 0.03, 0.3),
      }}
    >
      {children}
    </motion.div>
  );
}
